export default (params) => ({
  trigger: {
    name: 'promo_labels.read_more',
    params: params,
  },
  config: {
    schema: {
      subject_type: {
        enum: [
          'item',
          'label',
        ],
      },
      subject_id: {
        type: 'string',
      },
    },
    event: {
      name: 'read_explanation',
      params: {
        sub_feature: null,
      },
    },
  },
});
